const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

class ApiService {
  // Helper method for fetch requests
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error(`API request failed: ${endpoint}`, error);
      throw error;
    }
  }

  // KPI Values
  async getKpiValues() {
    return this.request('/kpi-values');
  }

  async updateKpiValues(values) {
    return this.request('/kpi-values', {
      method: 'POST',
      body: JSON.stringify(values),
    });
  }

  // KPI Goals
  async getKpiGoals() {
    return this.request('/kpi-goals');
  }

  async updateKpiGoals(goals) {
    return this.request('/kpi-goals', {
      method: 'POST',
      body: JSON.stringify(goals),
    });
  }

  // Configuration
  async getConfig(key) {
    return this.request(`/config/${key}`);
  }

  async updateConfig(key, value) {
    return this.request(`/config/${key}`, {
      method: 'POST',
      body: JSON.stringify(value),
    });
  }

  // File Upload
  async uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    return this.request('/upload', {
      method: 'POST',
      headers: {}, // Let browser set Content-Type for FormData
      body: formData,
    });
  }

  // Manual Overrides
  async getManualOverrides() {
    return this.request('/manual-overrides');
  }

  async saveManualOverride(kpiKey, value, overriddenBy) {
    return this.request('/manual-overrides', {
      method: 'POST',
      body: JSON.stringify({ kpiKey, value, overriddenBy }),
    });
  }

  async deleteManualOverride(kpiKey) {
    return this.request(`/manual-overrides/${kpiKey}`, {
      method: 'DELETE',
    });
  }

  // Health check
  async healthCheck() {
    return this.request('/health');
  }
}

export default new ApiService();